class ProductQuickView extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      description: '.js-qv-product-description'
    }

    this.qvATC = this.querySelector('.qv-add-to-cart');

    this.qvDrawer = null;
    this.boundOpenHandler = this.openHandler.bind(this);
    this.boundKeydownHandler = this.handleKeyDown.bind(this);
    this.boundOutsideClickHandler = this.handleOutsideClick.bind(this);
    this.contentWrapper = this.querySelector('.product-qv-content-wrapper');

    this.aiSearchId;
    this.productHandle;
  }

  connectedCallback() {
    this.qvDrawer = this.querySelector(".product-qv-drawer-wrapper");
    
    this.qvDrawer.addEventListener('click', this.trackATC.bind(this));

    // Global event listeners
    document.addEventListener("click", this.boundOpenHandler);
    document.addEventListener("keydown", this.boundKeydownHandler);
    document.addEventListener("click", this.boundOutsideClickHandler);
  }

  disconnectedCallback() {

    this.qvDrawer.removeEventListener('click', this.trackATC.bind(this));
    document.removeEventListener("click", this.boundOpenHandler);
    document.removeEventListener("keydown", this.boundKeydownHandler);
    document.removeEventListener("click", this.boundOutsideClickHandler);
  }

  trackATC(){
   if (!event.target.classList.contains('qv-add-to-cart') || !this.aiSearchId) return;

    const interactionType = "isAddedToCart";
    
    fetch(`${window.theme.apiUrl}/api/ai/search/productInteraction`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          handle: this.productHandle,
          searchId: this.aiSearchId,
          type: interactionType
        })
      })
      .then((response) => {
          if (!response.ok) {
              var error = new Error(response.status);
              throw error;
          }
          return response.json();
      })
      .then((response) => {
          console.log(response);
      })
  }

  openHandler(e) {
    const trigger = e.target.closest(".js-open-qv");
    const closeTrigger = e.target.closest(".product-qv-close, .qv-add-to-cart");
    

    if (trigger) {
      e.preventDefault();
      const aiQuery = trigger.dataset.aiQuery ?? false;
      this.aiSearchId = trigger.dataset.aiSearchId ?? false;
      this.productHandle = trigger.dataset.handle;
      
      this.openModal(this.productHandle, aiQuery);

      
      bodyScrollLock.disableBodyScroll(this.contentWrapper);
      
    } else if (closeTrigger) {
      this.closeModal();
    }
  }



  handleOutsideClick(e) {
    if (
      this.qvDrawer.classList.contains("open") &&
      !e.target.closest(".product-qv-drawer")
    ) {
      this.closeModal();
    }
  }

  handleKeyDown(e) {
    if (e.key === "Escape" && this.qvDrawer.classList.contains("open")) {
      this.closeModal();
    }
  }

  async openModal(handle, aiQuery = false) {


    //get ai query -- fetch simultaneously
    let fetchAiAnswer = null;
    if (aiQuery) {

      const params = new URLSearchParams({
        query: aiQuery,
        handle: handle,
        searchId: this.aiSearchId || ""
      }).toString();

      fetchAiAnswer = fetch(`${window.theme.apiUrl}/api/ai/search/productAnswer?${params}`, {credentials: 'include'})
    }

    await fetch(`${window.Shopify.routes.root}products/${handle}?view=qv`)
      .then((res) => res.text())
      .then((html) => {
        const temp = document.createElement("div");
        temp.innerHTML = html;
        const content = temp.querySelector(".product-qv-content-container");

        if (content) {
          const wrapper = this.qvDrawer.querySelector(".product-qv-content-wrapper");
          wrapper.innerHTML = "";
          wrapper.appendChild(content);

          if (aiQuery) {
            const descriptionElement = this.querySelector(this.selectors.description);
            const description = descriptionElement.innerHTML;

            descriptionElement.classList.add('loading');

            //clear description element. to prepare for the ai content
            descriptionElement.innerHTML = "";

            //copy description to alt description container
            const altDescription = this.querySelector('.js-qv-alternate-description-container');
            altDescription.innerHTML = description;
            altDescription.classList.add('active');

            //hide label 2 container
            //this.querySelector('.js-qv-product-upsell-wrapper').style.display = "none";

            //add skeleton loading
            descriptionElement.innerHTML =
            `<div class="skeleton-description">
              <div class="skeleton-line short"></div>
              <div class="skeleton-line"></div>
              <div class="skeleton-line"></div>
              <div class="skeleton-line"></div>
            </div>`

            
          }

          this.initCarousel();

          document.documentElement.classList.add("qv--open");
          document.body.classList.add("qv--open");
          this.qvDrawer.classList.add("open");
        }
      })
      .catch(() => {
        console.warn("QV failed, redirecting");
        window.location.href = `${window.Shopify.routes.root}products/${handle}`;
      });
    
    //handle aiquery if exists
    if (aiQuery) {
      fetchAiAnswer
        .then((res) => res.json())
        .then((response) => {
          const answer = response.results.answer;
          const descriptionElement = this.querySelector(this.selectors.description);
          
          //append answer to description element. Append asterisk at the end
          descriptionElement.innerHTML = `<b><i>${window.theme.strings.qv.ai.descriptionPrefix}</i></b> ${answer}*`;
          descriptionElement.classList.remove('loading');

          this.querySelector('.js-qv-product-description-container').classList.add('has-ai-content');
        })
    }
  }


  /*
  handleAIContent(aiContentSelector) {
    const aiContent = document.querySelector(aiContentSelector);

    if (!aiContent) return;

    const descriptionElement = this.querySelector('.js-qv-product-description');
    const description = descriptionElement.innerHTML;

    //copy description to alt description container
    const altDescription = this.querySelector('.js-qv-alternate-description-container');
    altDescription.innerHTML = description;
    altDescription.classList.add('active');

    //add ai content to the description element
    descriptionElement.innerHTML = aiContent.innerHTML;

    //hide label 2 container
    this.querySelector('.js-qv-product-upsell-wrapper').style.display = "none";

    this.querySelector('.js-qv-product-description-container').classList.add('has-ai-content');
  }
  */

  closeModal() {
    this.qvDrawer.classList.add("closing");
    setTimeout(() => {
      this.qvDrawer.classList.remove("open", "closing");
    }, 400);
    document.documentElement.classList.remove("qv--open");
    document.body.classList.remove("qv--open");

    bodyScrollLock.enableBodyScroll(this.contentWrapper);
  }

  initCarousel() {
    const carousel = this.qvDrawer.querySelector(".js-flickity-carousel");
    if (carousel && !carousel.classList.contains("is-initialized")) {
      const flkty = new Flickity(carousel, {
        imagesLoaded: true,
        wrapAround: true,
        pageDots: false,
        lazyLoad: true,
        contain: true,
        cellAlign: "left",
        prevNextButtons: false
      });

      const prev = this.qvDrawer.querySelector(".flickity-prev");
      const next = this.qvDrawer.querySelector(".flickity-next");

      if (prev && next) {
        prev.addEventListener("click", () => flkty.previous());
        next.addEventListener("click", () => flkty.next());
      }

      carousel.classList.add("is-initialized");
    }
  }
}

customElements.define("product-quickview", ProductQuickView);
